export default __webpack_public_path__ + "static/our-tiny-home-kitchen-ffe871e07b6e2efe81949619d8f4b1c0.png";